goog.provide("shadow.js.shim.module$$mui$material$FormControl$default");
shadow.js.shim.module$$mui$material$FormControl$default = shadow.js.shim.module$$mui$material$FormControl.default;
